<template>
  <v-container>
    <v-row class="mt-4">
      <v-col cols="12" lg="6">
        <div class="title">{{$t('company')}}</div>
        <div class="desc" v-html="$t('companyDesc')"></div>
      </v-col>
      <v-col cols="12" lg="6" style="display:flex;justify-content: center;">
        <v-img src="/assets/robot.svg" height="auto" width="auto" class="mx-auto featureCard"
          style="background-color: #ffffff99; border-radius: 20px; "></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="instructionCard">
          <div class="title">{{$t('nluTitle')}}</div>
          <div class="desc">{{$t('nluDesc')}}</div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <v-card class="instructionCard">
          <div class="title">{{$t('sttTitle')}}</div>
          <div class="desc">{{$t('sttDesc')}}</div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <v-card class="instructionCard">
          <div class="title">{{$t('ttsTitle')}}</div>
          <div class="desc">{{$t('ttsDesc')}}</div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  export default {
    name: "About"
  };
</script>
<style scoped>
  .instructionCard {
    padding: 24px;
    border-bottom: 3px solid #adb5bd !important;
    box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
  }

  .instructionCard:hover {
    padding: 24px;
    border-bottom: 3px solid #787ff7 !important;
    box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
  }

  .title {
    font-weight: 500;
    text-align: left;
    line-height: 1.5;
    font-size: 20px;
    color: #2c3e50;
    margin-bottom: 20px;
  }

  .desc {
    text-align: justify;
    line-height: 1.5;
    font-size: 16px;
    color: #2c3e50;
  }
</style>